import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoleViewService } from './role-view.service';
import { environment } from 'src/environments/environment';
import { catchError, Observable, throwError, firstValueFrom } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}
@Injectable({
  providedIn: 'root'
})
export class UserDashboardService {

  userId = '';
  userName = '';
  userEmail = '';
  baseUrl: string = environment?.baseApiUrl + environment?.userApiPath;
  // baseUrl: string = `https://4ghbby6mxa.execute-api.us-west-2.amazonaws.com/dev/`;

  userIdentifier = '';
  userUuid: any;
  constructor(private readonly http: HttpClient, private readonly _roleViewService: RoleViewService) {
    this.userId = this._roleViewService.getWorkdayId();
    this.userName = this._roleViewService.getUserName();
    this.userIdentifier = this._roleViewService.getUserName();
    this.userEmail = this._roleViewService.getUserEmail();
    this._roleViewService.getUserUuid$().subscribe(uuid => {
      this.userUuid = uuid;
    });
  }

  getUserDashboardData(isInRREReview = false): Observable<any> {
    const url = `${this.baseUrl}fetchUserDashboardDetails${environment?.proxy}?userId=${this.userEmail}&isInRREReview=${isInRREReview}`;
    return this.http.get(url);
  }

  fetchUserProjectDetails(projectId: string, departmentId = ''): Observable<any> {
    let url = `${this.baseUrl}fetchUserProjectDetails${environment?.proxy}?userId=${this.userEmail}&projectId=${projectId}`;
    if (departmentId) {
      url += `&departmentId=${departmentId}`;
    }
    console.info("Fetching project details with URL:", url);
    return this.http.get(url).pipe(
      catchError(this.handleError.bind(this))
    );;
  }

  fetchSelectedDeptTeamMembers(departmentId: string, projectId: string): Observable<any> {
    const url = `${this.baseUrl}fetchSelectedDeptTeamMembers${environment?.proxy}?departmentId=${departmentId}&projectId=${projectId}`;
    return this.http.get(url).pipe(
      catchError(this.handleError.bind(this))
    );;
  }


  updateDeptSubTaskAssignee(request: any): Observable<any> {
    const url = `${this.baseUrl}updateDeptSubTaskAssignee${environment?.proxy}?userId=${this.userEmail}`;
    const payload = {
      ...request,
      userName: this.userName,
      userIdentifier: this.userIdentifier,
    };
    console.info(request)
    return this.http.post(url, payload, httpOptions).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  approveRejectProjectSubTaskStatus(payload: {
    userId: string;
    projectId: string;
    departmentId: string;
    userComments: string;
    subTaskStatus: 'APPROVED' | 'REWORK';
  }): Observable<any> {
    const url = `${this.baseUrl}approveRejectProjectSubTaskStatus${environment?.proxy}`;
    const reqPayload = {
      ...payload,
      userIdentifier: this.userIdentifier
    };
    return this.http.post(url, reqPayload, httpOptions).pipe(
      catchError(this.handleError.bind(this))
    );
  }
  updateDocumentStatus(request: {
    projectId: number;
    departmentId: string;
    fileName: string;
    documentStatus: string;
    userComments?: string; // optional comments
  }): Observable<any> {
    const url = `${this.baseUrl}updateDocumentStatus${environment?.proxy}?userIdentifier=${this.userIdentifier}`;

    const payload = {
      ...request,
      userName: this.userName,
      userIdentifier: this.userIdentifier
    };

    console.info('Updating document status with payload:', payload, 'URL:', url);

    return this.http.post(url, payload, httpOptions).pipe(
      catchError(this.handleError.bind(this))
    );
  }
  
  private handleError(_error: any) {
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }

  async searchAllUsersDetails(searchValue: string): Promise<any> {
    const url = `${this.baseUrl}searchAllUsersDetails${environment?.proxy}?searchValue=${searchValue}`;
    return firstValueFrom(this.http.get(url).pipe(
      catchError(this.handleError.bind(this))
    ));
  }
}
